"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("normalize.css/normalize.css");
var React = require("react");
var react_dom_1 = require("react-dom");
var react_redux_1 = require("react-redux");
var config_1 = require("./config");
var App_1 = require("./container/App");
require("./index.css");
var analytics = require("./infra/analytics");
var firebase = require("./infra/firebase");
var redux_1 = require("./redux");
var register_service_worker_1 = require("./register-service-worker");
analytics.initialize();
firebase.initialize();
var store = redux_1.default();
react_dom_1.render(React.createElement(react_redux_1.Provider, { store: store },
    React.createElement(App_1.default, null)), document.getElementById(config_1.default.rootId));
register_service_worker_1.default();



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 283
// module chunks = 0